/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    type?: number;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

